import * as React from 'react';
import App from 'owa-application/lib/components/App';
import { SkipLinkPlaceholder, SkipLinkPlaceholderHandle } from 'owa-skip-link';
import { SearchBoxContainerHandle } from 'owa-search';
import getStore from '../store/store';
import { getBootstrapOptions } from '../optionsRegistry';
import { observer } from 'mobx-react-lite';
import { OwaSuiteHeader } from 'owa-suite-header';
import { Module } from 'owa-bootstrap';
import { lazySetupAppModuleKeys } from './lazy/lazyFunctions';
import { useLazyKeydownHandler } from 'owa-hotkeys';

export interface AppModuleProps {
    wrapSuiteHeader?: (suiteHeader: React.ReactNode) => React.ReactNode;
}

export default observer(function AppModule(props: AppModuleProps) {
    useLazyKeydownHandler(undefined, lazySetupAppModuleKeys.importAndExecute, undefined);

    // we will default to the mail module
    const currentModule = getStore().module || Module.Mail;
    const appModuleProps = getBootstrapOptions(currentModule)!.appModuleProps!;
    const skipLinkRef = React.useRef<SkipLinkPlaceholderHandle>(null);
    const searchBoxRef = React.useRef<SearchBoxContainerHandle>(null);
    const isSkiplinkEnabled = appModuleProps.isSkiplinkEnabled?.();
    const renderSkipLinkPlaceholder = React.useCallback(() => {
        return isSkiplinkEnabled ? <SkipLinkPlaceholder ref={skipLinkRef} /> : undefined;
    }, [isSkiplinkEnabled]);

    const headerInfo = appModuleProps.getHeaderInfo?.(searchBoxRef);
    const headerProps = headerInfo?.props;
    if (headerProps && props.wrapSuiteHeader) {
        headerProps.wrapSuiteHeader = props.wrapSuiteHeader;
    }
    const renderHeader = React.useCallback(() => {
        const OverrideHeader = appModuleProps.overrideHeader?.();
        return OverrideHeader ? (
            <OverrideHeader />
        ) : headerProps ? (
            <OwaSuiteHeader {...headerProps} />
        ) : undefined;
    }, [
        currentModule,
        headerProps?.searchAlignmentWidth,
        headerProps?.enableResponsiveLayout,
        headerInfo?.changes,
    ]);

    return (
        <App renderHeader={renderHeader} renderSkipLinkPlaceholder={renderSkipLinkPlaceholder}>
            {appModuleProps.renderModule(searchBoxRef, skipLinkRef)}
        </App>
    );
});
